export default __webpack_public_path__ + "static/media/13.9ba9aee2.jpg";